import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SyncProvider } from "./contexts/SyncContext";
import { LanguageProvider } from "./contexts/LanguageContext";
// Build refresh - Dec 14, 2025
import LandingPage from "./pages/LandingPage";
import DashboardLayout from "./components/layout/DashboardLayout";
import CoverPage from "./pages/dashboard/CoverPage";
import DashboardHome from "./pages/dashboard/DashboardHome";
import MenuPage from "./pages/dashboard/MenuPage";
import ClassesPage from "./pages/dashboard/ClassesPage";
import StudentsPage from "./pages/dashboard/StudentsPage";
import SchedulePage from "./pages/dashboard/SchedulePage";
import GradeBookPage from "./pages/dashboard/GradeBookPageNew";
import CurriculumPage from "./pages/dashboard/CurriculumPage";
import LessonPlansPage from "./pages/dashboard/LessonPlansPage";
import AssessmentTasksPage from "./pages/dashboard/AssessmentTasksPage";
import RollCallPage from "./pages/dashboard/RollCallCalendarPage";
import AssessmentSubmissionsPage from "./pages/dashboard/AssessmentSubmissionsPage";
import ChangePasswordPage from "./pages/dashboard/ChangePasswordPage";
import LoginPage from "./pages/auth/LoginPage";
import ImprovedLoginPage from "./pages/auth/ImprovedLoginPage";
import CoordinatorLoginPage from "./pages/auth/CoordinatorLoginPage";
import CoordinatorDashboard from "./pages/coordinator/CoordinatorDashboard";
import ParentLoginPage from "./pages/parent/ParentLoginPage";
import ParentDashboard from "./pages/parent/ParentDashboard";
import ReportCardViewerPage from "./pages/parent/ReportCardViewerPage";
import PublishReportsPage from "./pages/admin/PublishReportsPage";
import CreateParentAccountsPage from "./pages/admin/CreateParentAccountsPage";
import AdminResetPage from "./pages/admin/AdminResetPage";
import LoginHealthPage from "./pages/admin/LoginHealthPage";
import PrincipalCommentsPage from "./pages/admin/PrincipalCommentsPage";
import BulkUploadPage from "./pages/admin/BulkUploadPage";
import ViewReportCardsPage from "./pages/admin/ViewReportCardsPage";
import GradeCompletionPage from "./pages/dashboard/GradeCompletionPage";
import StudentLoginPage from "./pages/student/StudentLoginPage";
import StudentDashboardPage from "./pages/student/StudentDashboardPage";
import ResourceManagementPage from "./pages/dashboard/ResourceManagementPage";
import TimetablePage from "./pages/dashboard/TimetablePage";
import MasterTimetablePage from "./pages/dashboard/MasterTimetablePage";
import YearlyPlannerPage from "./pages/dashboard/YearlyPlannerPage";
import PrimaryCurriculumPage from "./pages/dashboard/PrimaryCurriculumPage";
import Year12ICTCurriculumPage from "./pages/dashboard/Year12ICTCurriculumPage";
import ChemistryCurriculumPage from "./pages/dashboard/ChemistryCurriculumPage";
import EconomicsCurriculumPage from "./pages/dashboard/EconomicsCurriculumPage";
import PhysicsCurriculumPage from "./pages/dashboard/PhysicsCurriculumPage";
import FrenchCurriculumPage from "./pages/dashboard/FrenchCurriculumPage";
import GeographyCurriculumPage from "./pages/dashboard/GeographyCurriculumPage";
import MathematicsCurriculumPage from "./pages/dashboard/MathematicsCurriculumPage";
import AgricultureCurriculumPage from "./pages/dashboard/AgricultureCurriculumPage";
import JuniorMathematicsCurriculumPage from "./pages/dashboard/JuniorMathematicsCurriculumPage";
import BiologyCurriculumPage from "./pages/dashboard/BiologyCurriculumPage";
import AccountingCurriculumPage from "./pages/dashboard/AccountingCurriculumPage";
import HistoryCurriculumPage from "./pages/dashboard/HistoryCurriculumPage";
import ESLCurriculumPage from "./pages/dashboard/ESLCurriculumPage";
import JuniorScienceCurriculumPage from "./pages/dashboard/JuniorScienceCurriculumPage";
import SeniorFrenchCurriculumPage from "./pages/dashboard/SeniorFrenchCurriculumPage";
import DevelopmentStudiesCurriculumPage from "./pages/dashboard/DevelopmentStudiesCurriculumPage";
import SocialScienceCurriculumPage from "./pages/dashboard/SocialScienceCurriculumPage";
import CourseMaterialsPage from "./pages/dashboard/CourseMaterialsPage";
import HomeEconomicsCurriculumPage from "./pages/dashboard/HomeEconomicsCurriculumPage";
import StudentSubjectAssignment from "./pages/dashboard/StudentSubjectAssignment";
import StreamDistributionReport from "./pages/dashboard/StreamDistributionReport";
import TeacherSignInPage from "./pages/dashboard/TeacherSignInPage";
import TeacherAttendanceDashboard from "./pages/dashboard/TeacherAttendanceDashboard";
import CoordinatorTeacherAttendance from "./pages/coordinator/CoordinatorTeacherAttendance";
import LeaveRequestsPage from "./pages/admin/LeaveRequestsPage";
import SendRemindersPage from "./pages/admin/SendRemindersPage";
import DisciplinePage from "./pages/dashboard/DisciplinePage";
import IncidentReportsPage from "./pages/dashboard/IncidentReportsPage";
import SyllabusProgressPage from "./pages/dashboard/SyllabusProgressPage";
import CurriculumCompletionPage from "./pages/dashboard/CurriculumCompletionPage";
import AILessonPlannerPage from "./pages/dashboard/AILessonPlannerPage";
import MyAttendancePage from "./pages/dashboard/MyAttendancePage";
import StudentSubmissionsPage from "./pages/StudentSubmissionsPage";
import CurriculumOverviewPage from "./pages/dashboard/CurriculumOverviewPage";
import IAProgramPage from "./pages/dashboard/IAProgramPage";
import StudyNotesPage from "./pages/dashboard/StudyNotesPage";
import StoryGeneratorPage from "./pages/dashboard/StoryGeneratorPage";
import ExamMarkingPage from "./pages/dashboard/ExamMarkingPage";
import SmsNotificationsPage from "./pages/dashboard/SmsNotificationsPage";
import QuickCheckProgressPage from "./pages/dashboard/QuickCheckProgressPage";
import ResourceLibraryPage from "./pages/dashboard/ResourceLibraryPage";
import PlanningWorkbookPage from "./pages/dashboard/PlanningWorkbookPage";
import CourseGeneratorPage from "./pages/dashboard/CourseGeneratorPage";
import StudentEnrollmentPage from "./pages/dashboard/StudentEnrollmentPage";
import CertificatesPage from "./pages/dashboard/CertificatesPage";
import PerformanceAnalysisPage from "./pages/dashboard/PerformanceAnalysisPage";
import TermDatesPage from "./pages/dashboard/TermDatesPage";
import AttendanceOverviewPage from "./pages/dashboard/AttendanceOverviewPage";
import PrimaryResourceLibraryPage from "./pages/dashboard/PrimaryResourceLibraryPage";
import TeachingProgressPage from "./pages/dashboard/TeachingProgressPage";
import ActivitiesPage from "./pages/dashboard/ActivitiesPage";
import LiteracyProgramPage from "./pages/dashboard/LiteracyProgramPage";
import ParentReportPage from "./pages/ParentReportPage";
import IACalendarPage from "./pages/dashboard/IACalendarPage";
import PendingApprovalsPage from "./pages/dashboard/PendingApprovalsPage";

function App() {
  return (
    <SyncProvider>
      <LanguageProvider>
        <Router>
          <Toaster position="top-center" richColors />
          <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<ImprovedLoginPage />} />
          <Route path="/login-old" element={<LoginPage />} />
          
          {/* Coordinator Routes */}
          <Route path="/coordinator/login" element={<CoordinatorLoginPage />} />
          <Route path="/coordinator/dashboard" element={<CoordinatorDashboard />} />
          <Route path="/coordinator/teacher-attendance" element={<CoordinatorTeacherAttendance />} />
          
          {/* Parent Portal Routes */}
          <Route path="/parent/login" element={<ParentLoginPage />} />
          <Route path="/r/:token" element={<ParentReportPage />} />
          <Route path="/parent/dashboard" element={<ParentDashboard />} />
          <Route path="/parent/report/:year/:term" element={<ReportCardViewerPage />} />
          
          {/* Protected Dashboard Routes */}
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<MenuPage />} />
            <Route path="analytics" element={<DashboardHome />} />
            <Route path="classes" element={<ClassesPage />} />
            <Route path="students" element={<StudentsPage />} />
            <Route path="assessments" element={<AssessmentTasksPage />} />
            <Route path="roll-call" element={<RollCallPage />} />
            <Route path="schedule" element={<SchedulePage />} />
            <Route path="gradebook" element={<GradeBookPage />} />
            <Route path="curriculum" element={<CurriculumPage />} />
            <Route path="lesson-plans" element={<LessonPlansPage />} />
            <Route path="submissions" element={<AssessmentSubmissionsPage />} />
            <Route path="change-password" element={<ChangePasswordPage />} />
            {/* Admin Routes */}
            <Route path="grade-completion" element={<GradeCompletionPage />} />
            <Route path="publish-reports" element={<PublishReportsPage />} />
            <Route path="view-report-cards" element={<ViewReportCardsPage />} />
            <Route path="student-report/:studentId" element={<ReportCardViewerPage />} />
            <Route path="create-parent-accounts" element={<CreateParentAccountsPage />} />
            <Route path="admin-reset" element={<AdminResetPage />} />
            <Route path="login-health" element={<LoginHealthPage />} />
            <Route path="principal-comments" element={<PrincipalCommentsPage />} />
            <Route path="resources" element={<ResourceManagementPage />} />
            <Route path="course-materials" element={<CourseMaterialsPage />} />
            <Route path="bulk-upload" element={<BulkUploadPage />} />
            <Route path="timetable" element={<TimetablePage />} />
            <Route path="master-timetable" element={<MasterTimetablePage />} />
            <Route path="yearly-planner" element={<YearlyPlannerPage />} />
            <Route path="primary-curriculum" element={<PrimaryCurriculumPage />} />
            <Route path="year12-ict" element={<Year12ICTCurriculumPage />} />
            <Route path="chemistry" element={<ChemistryCurriculumPage />} />
            <Route path="economics" element={<EconomicsCurriculumPage />} />
            <Route path="physics" element={<PhysicsCurriculumPage />} />
            <Route path="french" element={<FrenchCurriculumPage />} />
            <Route path="geography" element={<GeographyCurriculumPage />} />
            <Route path="mathematics" element={<MathematicsCurriculumPage />} />
            <Route path="agriculture" element={<AgricultureCurriculumPage />} />
            <Route path="junior-mathematics" element={<JuniorMathematicsCurriculumPage />} />
            <Route path="biology" element={<BiologyCurriculumPage />} />
            <Route path="accounting" element={<AccountingCurriculumPage />} />
            <Route path="history" element={<HistoryCurriculumPage />} />
            <Route path="esl" element={<ESLCurriculumPage />} />
            <Route path="junior-science" element={<JuniorScienceCurriculumPage />} />
            <Route path="senior-french" element={<SeniorFrenchCurriculumPage />} />
            <Route path="development-studies" element={<DevelopmentStudiesCurriculumPage />} />
            <Route path="social-science" element={<SocialScienceCurriculumPage />} />
            <Route path="home-economics" element={<HomeEconomicsCurriculumPage />} />
            <Route path="ict-curriculum" element={<Navigate to="/dashboard/resource-library" replace />} />
            <Route path="student-subjects" element={<StudentSubjectAssignment />} />
            <Route path="stream-report" element={<StreamDistributionReport />} />
            <Route path="teacher-signin" element={<TeacherSignInPage />} />
            <Route path="my-attendance" element={<MyAttendancePage />} />
            <Route path="teacher-attendance" element={<TeacherAttendanceDashboard />} />
            <Route path="leave-requests" element={<LeaveRequestsPage />} />
            <Route path="send-reminders" element={<SendRemindersPage />} />
            {/* Deputy Principal & Academic Principal Routes */}
            <Route path="discipline" element={<DisciplinePage />} />
            <Route path="incidents" element={<IncidentReportsPage />} />
            <Route path="syllabus-progress" element={<SyllabusProgressPage />} />
            <Route path="curriculum-completion" element={<CurriculumCompletionPage />} />
            <Route path="curriculum-overview" element={<CurriculumOverviewPage />} />
            <Route path="ai-lesson-planner" element={<AILessonPlannerPage />} />
            <Route path="student-submissions" element={<StudentSubmissionsPage />} />
            <Route path="ia-program" element={<IAProgramPage />} />
            <Route path="study-notes" element={<Navigate to="/dashboard/ai-lesson-planner?tab=notes" replace />} />
            <Route path="story-generator" element={<StoryGeneratorPage />} />
            <Route path="exam-marking" element={<ExamMarkingPage />} />
            <Route path="sms-notifications" element={<SmsNotificationsPage />} />
            <Route path="quick-check-progress" element={<QuickCheckProgressPage />} />
            <Route path="resource-library" element={<ResourceLibraryPage />} />
            <Route path="primary-resource-library" element={<PrimaryResourceLibraryPage />} />
            <Route path="planner" element={<PlanningWorkbookPage />} />
            <Route path="course-generator" element={<CourseGeneratorPage />} />
            <Route path="student-enrollment" element={<StudentEnrollmentPage />} />
            <Route path="certificates" element={<CertificatesPage />} />
            <Route path="performance" element={<PerformanceAnalysisPage />} />
            <Route path="term-dates" element={<TermDatesPage />} />
            <Route path="attendance-overview" element={<AttendanceOverviewPage />} />
            <Route path="teaching-progress" element={<TeachingProgressPage />} />
            <Route path="activities" element={<ActivitiesPage />} />
            <Route path="literacy-program" element={<LiteracyProgramPage />} />
            <Route path="ia-calendar" element={<IACalendarPage />} />
            <Route path="pending-approvals" element={<PendingApprovalsPage />} />
          </Route>
          
          {/* Student Routes */}
          <Route path="/student/login" element={<StudentLoginPage />} />
          <Route path="/student/dashboard" element={<StudentDashboardPage />} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
      </LanguageProvider>
    </SyncProvider>
  );
}

export default App;
